var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sort-by-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.173,
    height: 11.024,
    viewBox: "0 0 18.173 11.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13884",
    "data-name": "Path 13884",
    d: "M23.846,12.817H7.247a.918.918,0,0,1,0-1.817h16.6a.918.918,0,0,1,0,1.817Z",
    transform: "translate(-6.46 -11)",
    fill: "#1984bc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13885",
    "data-name": "Path 13885",
    d: "M19.823,18.817H7.368a.908.908,0,1,1,0-1.817H19.823a.908.908,0,0,1,0,1.817Z",
    transform: "translate(-6.46 -12.397)",
    fill: "#1984bc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13886",
    "data-name": "Path 13886",
    d: "M13.073,24.817h-5.7a.908.908,0,1,1,0-1.817h5.7a.908.908,0,1,1,0,1.817Z",
    transform: "translate(-6.46 -13.793)",
    fill: "#1984bc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSort);
export default __webpack_public_path__ + "static/media/icon-sort.2e95eb14a21c245b4cdced18cfdd989a.svg";
export { ForwardRef as ReactComponent };